import React, { Component } from "react";
import { Card, Container, Button, Spinner, Modal, Form, Row, Col } from "react-bootstrap";
import gql from "graphql-tag";
import { withRouter } from "react-router-dom";
import compose from "lodash.flowright";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import { components } from "react-select";
import SelectDropDown from "../selectdropdown/SelectDropDown";
import MultiSelect from "react-multi-select-component";
import "./_pdf.scss";
import {
  MathJax,
  MathJaxContext
} from "better-react-mathjax";

// ✅ TINYMCE + WIRIS (NO CDN)
import { Editor } from "@tinymce/tinymce-react";
import $ from "jquery";
import tinymce from "tinymce";
import "@wiris/mathtype-tinymce6";


window.$ = $;
window.tinymce = tinymce;
tinymce.baseURL = "/tinymce";


const FETCH_QUESTIONS = gql`
  query AIMLQuestionBankCollegePdf($id: Int!, $institute_id: Int!, $page: Int, $limit: Int) {
    getAIMLFiles:getAIMLQuestionBankCollegePdf(id: $id,institute_id:$institute_id,page:$page,limit:$limit) {
      file_name
      total_questions
      questions {
        id
        question
        option1
        option2
        option3
        option4
        answer
        explanation
        subject
        chapter
        topic
        question_theory
        class_id
        complexity_1
        exam_1
        exam
        qtype
        usageset_1
        question_theory_1,
        topic_ids,
        chapter_ids,
        subject_1
        compquestion
      }
    }
  }
`;


const FETCH_GLOBALS = gql` 
query($institution_id: Int!) {
    globals(institution_id: $institution_id){
        b_e_c_s_data {
            section_id
            class_id
            branch_id
            exam_id
          }
        exams{
            id
            exam
            exam_subjects{
                subject_id
                no_of_questions
            }
            avg_question_time
        }
        globalBranches{
            id
            branch_name
        }
        classes{
            id
            class
        }
        globalSections{
            id
            section_name
            exam_id
            branch_id
            category_id
        }
        subjects{
            id
            subject
            chapters{
                id
                chapter
                topics{
                    id
                    topic
                    # practice_percentage
                }
                class
            }
            state_chapters{
                id
                chapter
                exam_id
                state_topics{
                    id
                    topic
                }
                class
            }
        }
        questionTypes{
            id
            questiontype
        }
        questionTheory{
            id
            question_theory
        }
        complexity{
            id
            complexity
            
        }
    }
}

`;

const UPDATE_QUESTION = gql`
  mutation UpdateQuestion($id: Int!,$type:String!,$data: QuestionEditData) {
    updateAIMLQuestion(id: $id,type:$type, data: $data) {
      success
      message
    }
  }
`;

const DropdownIndicator = (props) =>
  components.DropdownIndicator && (
    <components.DropdownIndicator {...props}>
      <svg height="20" width="20" viewBox="0 0 20 20">
        <path fill="currentColor" d="M4.516 7.548l5.484 5.452 5.484-5.452" />
      </svg>
    </components.DropdownIndicator>
  );

const usageSetOptions = [
  { label: "Practice Test", value: 1 },
  { label: "Cumulative Test", value: 3 },
  { label: "Semi-Grand Test", value: 4 },
  { label: "Grand Test", value: 5 },
];

export const mathJaxConfig = {
  loader: {
    load: ["input/tex", "output/chtml"],
  },
  tex: {
    inlineMath: [
      ["$", "$"],
      ["\\(", "\\)"],
    ],
    displayMath: [
      ["$$", "$$"],
      ["\\[", "\\]"],
    ],
  },
  options: {
    skipHtmlTags: ["script", "noscript", "style", "textarea", "pre", "code"],
  },
};

/* ---------------- HTML CLEANER ---------------- */

const cleanHTML = (html = "") => {
  let clean = String(html)
    // Decode escaped line breaks so they render as actual HTML line breaks
    .replace(/&lt;br\s*\/?&gt;/gi, "<br />")
    .replace(/&amp;lt;br\s*\/?&amp;gt;/gi, "<br />")
    .replace(
      /(<p[^>]*>[\s\S]*?)(?:<br\s*\/?>|&nbsp;|\s)+(?=\s*<table)/gi,
      "$1"
    )
    .replace(
      /(<table[\s\S]*?>[\s\S]*?<\/table>)/gi,
      (table) =>
        table.replace(
          /<br\s*\/?>/gi,
          ""
        )
    )
    .replace(/&nbsp;/g, " ")
    .replace(/&#38;|&amp;/g, "&")
    .replace(/&#x00026;/g, "&")
    .replace(/&#x0*26;/gi, "&");

  // Convert raw newlines to <br /> if there are no block-level HTML tags
  if (!/<(p|div|table|tr|td|li|ul|ol|h[1-6])/i.test(clean)) {
    clean = clean.replace(/\n/g, "<br />");
  }

  return clean;
};

/* ---------------- MATH RENDERER ---------------- */

export const MathRenderer = React.memo(({
  text,
  uniqueKey
}) => {

  if (!text) return null;

  return (

    <MathJax
      dynamic
      hideUntilTypeset="first"
    >

      <div
        key={uniqueKey}
        style={{
          whiteSpace: "pre-wrap",
          // overflowX: "auto"
        }}

        dangerouslySetInnerHTML={{
          __html: cleanHTML(text)
        }}
      />

    </MathJax>

  );

});


/* ---------------- PROVIDER ---------------- */

export const MathProvider = ({
  children
}) => {
  return (
    <MathJaxContext
      version={3}
      config={mathJaxConfig}
    >
      {children}
    </MathJaxContext>
  );
};

/* ---------------- HELPER ---------------- */

const hasQtype8 = (qtype) => {
  if (!qtype) return false;
  return qtype.toString().split(",").map(x => x.trim()).includes("8");
};

class PdfQuestionsSec extends Component {
  state = {
    showModal: false,
    selectedQuestion: null,

    subject: "0",           // ✅ store id
    subjectVal: "",         // ✅ store object

    timeduration: "",

    classList: [],
    examList: [],
    chapterList: [],
    topicList: [],

    questionTypeList: [],

    questionTheoryOptions: [],
    complexityOptions: [],


    complexity: "0",
    complexityval: "",

    questionTheory: "0",
    questionTheoryVal: "",

    usageSet: "0",
    usageSetVal: "",

    chapterOptions: [],
    topicOptions: [],


    selectedAnswer: "",

    saving: false,
    saveMessage: "",
    saveError: false,


    filterSubject: [],
    filterChapter: [],
    filterTopic: [],

    filterChapterOptions: [],
    filterTopicOptions: [],
    filteredQuestions: [],
    page: 1,
    limit: 25,
    isRefetching: false,

    editorLoading: {
      question: true,
      option1: true,
      option2: true,
      option3: true,
      option4: true,
      explanation: true,
    },

  };

  editors = {};


  componentDidMount() {
    window._wrs_int_conf = {
      editorParameters: { viewer: "mathml" },
      serviceProviderProperties: {
        URI: "https://www.wiris.net/demo/plugins/app"
      }
    };

    const pdf = this.props.data.getAIMLFiles?.[0] || {};

    this.setState({
      filteredQuestions: pdf.questions || [],
      page: 1
    }, () => {
      setTimeout(() => this.setupLazyWiris(), 300);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.showModal && this.state.showModal) {
      setTimeout(this.initializeEditors, 200);
    }

    if (this.props.data.getAIMLFiles !== prevProps.data.getAIMLFiles) {
      const pdf = this.props.data.getAIMLFiles?.[0] || {};
      const prevPdf = prevProps.data.getAIMLFiles?.[0] || {};

      const stateUpdate = {
        filteredQuestions: pdf.questions || []
      };

      // Only reset page to 1 if the file has actually changed
      if (!prevPdf || pdf.file_name !== prevPdf.file_name) {
        stateUpdate.page = 1;
      }

      this.setState(stateUpdate, () => {
        setTimeout(() => this.setupLazyWiris(), 300);
      });
    }
  }

  setupLazyWiris = () => {
    if (window.WirisPlugin?.Parser) {
      try {
        const container = document.querySelector(".question-card-container");
        if (container) {
          window.WirisPlugin.Parser.initParse(container);
        }
      } catch (e) {
        console.error("WIRIS parse error:", e);
      }
    } else {
      if (!document.getElementById("wiris-script-global")) {
        const script = document.createElement("script");
        script.id = "wiris-script-global";
        script.src = "https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image";
        script.onload = () => {
          if (window.WirisPlugin?.Parser) {
            try {
              const container = document.querySelector(".question-card-container");
              if (container) {
                window.WirisPlugin.Parser.initParse(container);
              }
            } catch (e) {
              console.error("WIRIS parse error on load:", e);
            }
          }
        };
        document.body.appendChild(script);
      }
    }
  };


  renderHTML = (text) => {
    if (!text) return { __html: "" };

    let safeText = String(text)
      // Decode escaped line breaks so they render as actual HTML line breaks
      .replace(/&lt;br\s*\/?&gt;/gi, "<br />")
      .replace(/&amp;lt;br\s*\/?&amp;gt;/gi, "<br />");

    // Convert raw newlines to <br /> if there are no block-level HTML tags
    if (!/<(p|div|table|tr|td|li|ul|ol|h[1-6])/i.test(safeText)) {
      safeText = safeText.replace(/\n/g, "<br />");
    }

    const clean = safeText
      // remove anchor tags but keep text
      .replace(/<a[^>]*>(.*?)<\/a>/gi, "$1")

      // remove URLs
      .replace(/https?:\/\/[^\s"'<]+/g, "")

      // remove localhost URLs
      .replace(/localhost:[0-9]+\/[^\s"'<]*/g, "")

      // remove script/iframe/style
      .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
      .replace(/<iframe[\s\S]*?>[\s\S]*?<\/iframe>/gi, "")
      .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, "");

    return { __html: clean };
  };


  handleFilterSubject = (selectedSubjects) => {
    const g = this.props.globals?.globals || {};

    let chapters = [];

    selectedSubjects.forEach((sub) => {
      const subjectData = g.subjects.find(
        (s) => Number(s.id) === Number(sub.value)
      );

      if (subjectData?.chapters) {
        chapters.push(
          ...subjectData.chapters.map((c) => ({
            label: c.chapter,
            value: c.id,
          }))
        );
      }
    });

    this.setState({
      filterSubject: selectedSubjects,
      filterChapter: [],
      filterTopic: [],
      filterChapterOptions: chapters,
      filterTopicOptions: [],
    });
  };


  handleFilterChapter = (selected) => {
    const g = this.props.globals?.globals || {};
    let topics = [];

    g.subjects.forEach((s) => {
      s.chapters.forEach((c) => {
        if (selected.some((x) => x.value === c.id)) {
          topics.push(...(c.topics || []));
        }
      });
    });

    const topicOptions = topics.map((t) => ({
      label: t.topic,
      value: t.id,
    }));

    this.setState({
      filterChapter: selected,
      filterTopic: [],
      filterTopicOptions: topicOptions,
    });
  };


  handleFilterTopic = (selected) => {
    this.setState({ filterTopic: selected });
  };


  handleFilterSubmit = () => {
    const pdf = this.props.data.getAIMLFiles?.[0] || {};
    let questions = pdf.questions || [];

    const { filterSubject, filterChapter, filterTopic } = this.state;

    console.log("questions", questions)
    console.log("questions", this.state.filterSubject)

    let filtered = questions.filter((q) => {
      let match = true;

      // ✅ SUBJECT (MULTI)
      if (filterSubject.length > 0) {
        const subjectIds = filterSubject.map((s) => String(s.value));
        match =
          match &&
          q.subject &&
          subjectIds.includes(String(q.subject));
      }

      // ✅ CHAPTER
      if (filterChapter.length > 0) {
        const chapterIds = filterChapter.map((c) => String(c.value));

        const qChapters = (q.chapter_ids || "").split(",");

        match =
          match &&
          qChapters.some((id) => chapterIds.includes(id));
      }

      // ✅ TOPIC
      if (filterTopic.length > 0) {
        const topicIds = filterTopic.map((t) => String(t.value));

        const qTopics = (q.topic_ids || "").split(",");

        match =
          match &&
          qTopics.some((id) => topicIds.includes(id));
      }

      return match;
    });

    this.setState({ filteredQuestions: filtered, page: 1 }, () => {
      setTimeout(() => this.setupLazyWiris(), 300);
    });
  };

  handleModalClose = () => {
    if (window.tinymce) {
      window.tinymce.remove();   // 🔥 removes all editors
    }

    // also clear dataset flags
    document.querySelectorAll(".example").forEach(el => {
      delete el.dataset.mceInitialized;
    });

    this.editors = {};

    this.setState({ showModal: false });
  };

  /* ---------------- ACTIONS ---------------- */

  editQuestion = (q) => {
    const g = this.props.globals?.globals || {};

    // ✅ SUBJECT
    const subjectObj = g.subjects?.find(s => Number(s.id) === Number(q.subject));

    // ✅ CLASS
    const classList = (q.class_id || "")
      .toString()
      .split(",")
      .map(id => {
        const c = g.classes.find(x => Number(x.id) === Number(id));
        return c ? { label: c.class, value: c.id } : null;
      })
      .filter(Boolean);

    // ✅ EXAM
    const examList = (q.exam || "")
      .toString()
      .split(",")
      .map(id => {
        const e = g.exams.find(x => Number(x.id) === Number(id));
        return e ? { label: e.exam, value: e.id } : null;
      })
      .filter(Boolean);

    // ✅ CHAPTER
    const chapterList = (q.chapter_ids || "")
      .split(",")
      .map(id => {
        let found = null;
        g.subjects.forEach(s => {
          s.chapters.forEach(c => {
            if (Number(c.id) === Number(id)) {
              found = { label: c.chapter, value: c.id };
            }
          });
        });
        return found;
      })
      .filter(Boolean);

    // ✅ TOPIC
    const topicList = (q.topic_ids || "")
      .split(",")
      .map(id => {
        let found = null;
        g.subjects.forEach(s => {
          s.chapters.forEach(c => {
            c.topics.forEach(t => {
              if (Number(t.id) === Number(id)) {
                found = { label: t.topic, value: t.id };
              }
            });
          });
        });
        return found;
      })
      .filter(Boolean);

    // ✅ QUESTION TYPE
    const questionTypeList = (q.qtype || "")
      .split(",")
      .map(id => {
        const qt = g.questionTypes.find(x => Number(x.id) === Number(id));
        return qt ? { label: qt.questiontype, value: qt.id } : null;
      })
      .filter(Boolean);

    // ✅ COMPLEXITY
    const complexityObj = g.complexity.find(c => c.complexity === q.complexity_1);

    // ✅ THEORY
    const theoryObj = g.questionTheory.find(t => t.question_theory === q.question_theory_1);

    // ✅ USAGE
    const usageObj = usageSetOptions.find(u => u.label === q.usageset_1);

    // ✅ CHAPTER OPTIONS & TOPIC OPTIONS FOR DROP DOWNS
    const chapterOptions = subjectObj?.chapters?.map((c) => ({
      label: c.chapter,
      value: c.id,
    })) || [];

    let topics = [];
    if (subjectObj?.chapters) {
      subjectObj.chapters.forEach((chapter) => {
        if (chapterList.some((c) => Number(c.value) === Number(chapter.id))) {
          topics.push(...(chapter.topics || []));
        }
      });
    }
    const topicOptions = topics.map((t) => ({
      label: t.topic,
      value: t.id,
    }));

    const answerMap = {
      "1": "A",
      "2": "B",
      "3": "C",
      "4": "D",
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    };

    this.setState({
      showModal: true,
      selectedQuestion: q,

      subject: subjectObj?.id || "0",
      subjectVal: subjectObj
        ? { label: subjectObj.subject, value: subjectObj.id }
        : "",

      classList,
      examList,
      chapterList,
      topicList,
      questionTypeList,
      chapterOptions,
      topicOptions,

      complexityval: complexityObj
        ? { label: complexityObj.complexity, value: complexityObj.id }
        : "",

      questionTheoryVal: theoryObj
        ? { label: theoryObj.question_theory, value: theoryObj.id }
        : "",

      usageSetVal: usageObj || "",

      timeduration: q.timeduration || "",

      selectedAnswer: answerMap[String(q.answer).trim().toUpperCase()] || q.answer || "",

      saveMessage: "",
      saveError: false,
    });
  };

  setEditorLoaded = (field) => {
    this.setState((prev) => ({
      editorLoading: {
        ...prev.editorLoading,
        [field]: false,
      },
    }));
  };

  selecthandleChanges = (name, value) => {
    const g = this.props.globals?.globals || {};

    // SUBJECT
    if (name === "subject") {
      if (value !== "0") {
        const subjectData = g.subjects.find(
          (s) => Number(s.id) === Number(value)
        );

        const chapterOptions =
          subjectData?.chapters?.map((c) => ({
            label: c.chapter,
            value: c.id,
          })) || [];

        this.setState({
          subject: subjectData.id, // ✅ store ID
          subjectVal: {
            value: subjectData.id,
            label: subjectData.subject,
          }, // ✅ store object

          chapterOptions,
          topicOptions: [],
          chapterList: [],
          topicList: [],
        });
      } else {
        this.setState({
          subject: "0",
          subjectVal: "",
          chapterOptions: [],
          topicOptions: [],
          chapterList: [],
          topicList: [],
        });
      }
    }

    if (name === "usageSet") {

      let data = usageSetOptions.find((a) => a.value == value);
      this.setState({
        usageSetVal: {
          value: data.value,
          label: data.label
        }

      });
    }

    if (name === "complexity") {
      let data = this.props.globals?.globals?.complexity.find((a) => a.id == value);
      this.setState({
        complexityval: {
          value: data.id,
          label: data.complexity
        }

      });
    }

    if (name === "questionTheory") {
      let data = this.props.globals?.globals?.questionTheory.find((a) => a.id == value);
      this.setState({
        questionTheoryVal: {
          value: data.id,
          label: data.question_theory
        }

      });
    }
    // default
    // ONLY for simple fields
    this.setState({ [name]: value });
  };


  handleChapterChange = (selectedChapters) => {
    const g = this.props.globals?.globals || {};

    let topics = [];

    g.subjects.forEach((subject) => {
      subject.chapters.forEach((chapter) => {
        if (
          selectedChapters.some(
            (c) => Number(c.value) === Number(chapter.id)
          )
        ) {
          topics.push(...(chapter.topics || []));
        }
      });
    });

    const topicOptions = topics.map((t) => ({
      label: t.topic,
      value: t.id,
    }));

    this.setState({
      chapterList: selectedChapters,
      topicOptions,
      topicList: [], // reset
    });
  };

  /* ---------------- HANDLERS ---------------- */
  handleMulti = (val, name) => {
    this.setState({ [name]: val });
  };

  selecthandleInputChange = (val, name) => {
    this.setState({ [name]: val });
  };

  handleCheckboxChange = (opt, checked) => {
    let currentAnswers = this.state.selectedAnswer
      ? this.state.selectedAnswer.split(",").map(x => x.trim()).filter(Boolean)
      : [];
    if (checked) {
      if (!currentAnswers.includes(opt)) {
        currentAnswers.push(opt);
      }
    } else {
      currentAnswers = currentAnswers.filter(x => x !== opt);
    }
    currentAnswers.sort();
    this.setState({ selectedAnswer: currentAnswers.join(",") });
  };

  goBack = () => this.props.history.push("/exam_made_easy");

  getEditableContent = (html = "") => {
    if (!html) return "";
    if (html.includes("<svg")) return "";
    return html;
  };


  handleSave = async () => {
    this.setState({ saving: true, saveMessage: "", saveError: false });

    try {
      const g = this.props.globals?.globals || {};
      const isEditQtype8 = this.state.questionTypeList?.some(
        (qt) => String(qt.value) === "8"
      );

      const selectedSubject = g.subjects?.find(
        (s) => Number(s.id) === Number(this.state.subject)
      );

      const subject_name = selectedSubject?.subject || "";

      const chapter_ids = this.state.chapterList.map(i => i.value).join(",");
      const chapter_names = this.state.chapterList.map(i => i.label).join(",");

      const topic_ids = this.state.topicList.map(i => i.value).join(",");
      const topic_names = this.state.topicList.map(i => i.label).join(",");

      const class_ids = this.state.classList.map(i => i.value).join(",");

      const data = {
        institute_id: parseInt(Cookies.get("institutionid")),
        updated_by: parseInt(Cookies.get("userid")),

        class_id: class_ids,
        subject: parseInt(this.state.subject),
        subject_1: subject_name,

        chapter_ids,
        chapter: chapter_names,

        topic_ids,
        topic: topic_names,

        exam: this.state.examList.map(i => i.value).join(","),
        inputquestion: this.state.questionTypeList.map(i => i.value).join(","),

        complexity: parseInt(this.state.complexityval?.value) || 0,
        question_theory: parseInt(this.state.questionTheoryVal?.value) || 0,
        usageset: parseInt(this.state.usageSetVal?.value) || 0,
        usageset_1: this.state.usageSetVal?.label,

        entry_verify: 1,
        timeduration: Number(this.state.timeduration) || 0,

        question: this.editors["editor_question"]?.getContent() || "",
        option1: isEditQtype8 ? "" : (this.editors["editor_option1"]?.getContent() || ""),
        option2: isEditQtype8 ? "" : (this.editors["editor_option2"]?.getContent() || ""),
        option3: isEditQtype8 ? "" : (this.editors["editor_option3"]?.getContent() || ""),
        option4: isEditQtype8 ? "" : (this.editors["editor_option4"]?.getContent() || ""),
        explanation: this.editors["editor_explanation"]?.getContent() || "",
        answer: (() => {
          const revAnswerMap = { "A": "1", "B": "2", "C": "3", "D": "4" };
          const originalAnswer = this.state.selectedQuestion?.answer;
          if (/^[1-4]$/.test(String(originalAnswer).trim())) {
            return revAnswerMap[this.state.selectedAnswer] || this.state.selectedAnswer;
          }
          return this.state.selectedAnswer;
        })(),
      };

      const res = await this.props.updateQuestionMutation({
        variables: {
          id: this.state.selectedQuestion.id,
          type: "college",
          data
        }
      });

      const result = res?.data?.updateAIMLQuestion;

      if (result?.success) {
        const updatedQuestions = this.state.filteredQuestions.map((item) => {
          if (item.id === this.state.selectedQuestion.id) {
            return {
              ...item,
              ...data,
              qtype: data.inputquestion,
            };
          }
          return item;
        });

        this.setState({
          saving: false,
          saveMessage: result.message || "Updated successfully!",
          saveError: false,
          filteredQuestions: updatedQuestions
        });

        // ✅ WAIT 1.5 SECONDS → CLOSE MODAL
        setTimeout(() => {
          this.handleModalClose();
        }, 1500);
      } else {
        this.setState({
          saving: false,
          saveMessage: result.message || "Update failed",
          saveError: true
        });
      }

    } catch (err) {
      this.setState({
        saving: false,
        saveMessage: "Something went wrong",
        saveError: true
      });
    }
  };

  render() {
    const { loading, error, getAIMLFiles } = this.props.data;
    const g = this.props.globals?.globals || {};
    console.log("myState", this.state);



    if (loading || this.state.isRefetching)
      return (
        <div className="pdf-table-wrapper">
          <style>{`
            @keyframes pdfShimmer {
              0%   { background-position: -468px 0; }
              100% { background-position: 468px 0; }
            }
            .pdf-shimmer {
              background: #f1f5f9;
              background-image: linear-gradient(90deg, #eef2f7 0px, #f8fafc 40px, #eef2f7 80px);
              background-size: 936px 100%;
              background-repeat: no-repeat;
              border-radius: 8px;
              animation: pdfShimmer 1.4s linear infinite;
            }
          `}</style>

          {/* Toolbar shimmer */}
          <div className="pdf-table-toolbar">
            <div className="pdf-shimmer" style={{ width: 280, height: 40 }} />
            <div className="pdf-shimmer" style={{ width: 90, height: 28, borderRadius: 20 }} />
          </div>

          {/* Header shimmer */}
          <div style={{ display: "flex", alignItems: "center", gap: 16, padding: "12px 16px", marginTop: 8 }}>
            <div className="pdf-shimmer" style={{ width: 30, height: 14 }} />
            <div className="pdf-shimmer" style={{ flex: 1, height: 14 }} />
            <div className="pdf-shimmer" style={{ width: 60, height: 14 }} />
          </div>

          {/* Row shimmers */}
          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 16, padding: "16px" }}>
              <div className="pdf-shimmer" style={{ width: 28, height: 28, borderRadius: "50%" }} />
              <div className="pdf-shimmer" style={{ width: 20, height: 22 }} />
              <div className="pdf-shimmer" style={{ flex: 1, height: 14, maxWidth: 360 }} />
              <div className="pdf-shimmer" style={{ width: 36, height: 30, marginLeft: "auto" }} />
            </div>
          ))}
        </div>
      );

    if (error) return <div>Error loading</div>;

    const pdf = getAIMLFiles?.[0] || {};
    const questions = this.state.filteredQuestions || [];
    const { page = 1, limit = 25 } = this.state;
    const totalQuestions = pdf.total_questions || questions.length;
    const totalPages = Math.ceil(totalQuestions / limit);
    const startIndex = (page - 1) * limit;
    const paginatedQuestions = questions; // Paginated by backend

    const isEditQtype8 = this.state.questionTypeList?.some(
      (qt) => String(qt.value) === "8"
    );

    /* OPTIONS */
    const subjectOptions = (g.subjects || []).map((s) => ({
      label: s.subject,
      value: s.id,
    }));

    const classOptions = (g.classes || []).map((c) => ({
      label: c.class,
      value: c.id,
    }));

    const examOptions = (g.exams || []).map((e) => ({
      label: e.exam,
      value: e.id,
    }));

    const questionTypeOptions = (g.questionTypes || []).map((q) => ({
      label: q.questiontype,
      value: q.id,
    }));

    const questionTheoryOptions = (g.questionTheory || []).map((q) => ({
      label: q.question_theory,
      value: q.id,
    }));

    const complexityOptions = (g.complexity || []).map((c) => ({
      label: c.complexity,
      value: c.id,
    }));



    return (
      <MathJaxContext version={3} config={mathJaxConfig}>
        <Container className="mt-3">
          {/* HEADER */}
          <Card className="mb-4">
            <Card.Body className="">
              <Row className="">
                <Col sm={12}>
                  <div className="d-flex justify-content-between">
                    <div>
                      <h5>{pdf.file_name}</h5>
                      <small>Total: <b>{questions.length}</b></small>
                    </div>
                    <div>
                      <Button onClick={this.goBack} className="float-right"><i className="fa fa-arrow-left"></i>&nbsp;&nbsp;Back</Button>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="mt-3">
                <Col md={3}>
                  <Form.Label>Subject</Form.Label>
                  <MultiSelect
                    options={subjectOptions}
                    value={this.state.filterSubject}
                    onChange={(selected) => this.handleFilterSubject(selected)}
                  />
                </Col>

                <Col md={3}>
                  <Form.Label>Chapter</Form.Label>
                  <MultiSelect
                    options={this.state.filterChapterOptions}
                    value={this.state.filterChapter}
                    onChange={this.handleFilterChapter}
                  />
                </Col>

                <Col md={3}>
                  <Form.Label>Topic</Form.Label>
                  <MultiSelect
                    options={this.state.filterTopicOptions}
                    value={this.state.filterTopic}
                    onChange={this.handleFilterTopic}
                  />
                </Col>

                <Col md={3} className="d-flex align-items-end">
                  <Button onClick={this.handleFilterSubmit} className="me-2 f-14">
                    Apply Filter
                  </Button>
                  <Button
                    variant="secondary"
                    className="ms-2 f-14"
                    onClick={() => {
                      this.setState({
                        filterSubject: [],
                        filterChapter: [],
                        filterTopic: [],
                        filterChapterOptions: [],
                        filterTopicOptions: [],
                        filteredQuestions: pdf.questions || [],
                        page: 1
                      });
                    }}
                  >
                    Reset
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>


          <MathJax dynamic>
            <div className="question-card-container">
              {/* QUESTIONS */}
              {paginatedQuestions.map((q, idx) => (
                <Card className="mb-3 question-card" key={q.id}>
                  <Card.Body>

                    {/* HEADER */}
                    <div className="question-header">
                      <div className="q-number">#{startIndex + idx + 1}  <br />
                        QID:{q?.id}
                      </div>
                      <i
                        className="fas fa-edit edit-icon"
                        onClick={() => this.editQuestion(q)}
                      />
                    </div>

                    {/* BADGES */}
                    {/* META INFO */}
                    {/* META INLINE */}
                    <div className="meta-inline" >

                      <span><b>Exam:</b> {q.exam_1 || "-"}</span>

                      <span><b>Class:</b> {classOptions.filter((item) => +item.value === +q.class_id)[0]?.label || "-"}</span>

                      <span style={{ whiteSpace: 'pre-line' }}><b>Subject:</b> {q.subject_1 || "-"}</span>

                      <span style={{ whiteSpace: 'pre-line' }}><b>Chapter:</b> {q.chapter || "-"}</span>

                      <span style={{ whiteSpace: 'pre-line' }}><b>Topic:</b> {q.topic || "-"}</span>

                      <span style={{ whiteSpace: 'pre-line' }}><b>Type:</b> {q.qtype || "-"}</span>

                      <span style={{ whiteSpace: 'pre-line' }}><b>Complexity:</b> {q.complexity_1 || "-"}</span>

                      <span style={{ whiteSpace: 'pre-line' }}><b>Theory:</b> {q.question_theory_1 || "-"}</span>

                      {/* <span><b>Usage:</b> {q.usageset_1 || "-"}</span> */}

                    </div>

                    {/* QUESTION */}
                    <div className="question-box">
                      <div className="question-label">Question</div>

                      {q.compquestion != 0 && q.compquestion != null && q.compquestion != "" && (
                        <div className="comprehension-box mb-3" style={{ background: "#f8fafc", padding: "12px", borderRadius: "4px" }}>
                          <MathRenderer
                            text={q.compquestion}
                            uniqueKey={`comp-${q.id}`}
                            className="question-text"
                          />
                        </div>
                      )}

                      <MathRenderer
                        text={q.question}
                        uniqueKey={`q-${q.id}`}
                        className="question-text"
                      />
                    </div>

                    {/* OPTIONS */}
                    <div className="options-grid">
                      {[q.option1, q.option2, q.option3, q.option4].map((opt, i) => {
                        const label = ["A", "B", "C", "D"][i];
                        const cleanAnswers = String(q.answer || "")
                          .split(/[\s,]+/)
                          .map(ans => ans.replace(/[^A-Za-z0-9]/g, "").toUpperCase().trim())
                          .filter(Boolean);
                        const isAnswer = cleanAnswers.includes(label) || cleanAnswers.includes(String(i + 1));
                        return opt ? (
                          <div className={`option-card ${isAnswer ? "correct" : ""}`} key={i}>
                            <div className="option-label">{label}</div>
                            <MathRenderer text={opt} uniqueKey={`modal-opt-${q.id}-${i}`} />
                          </div>
                        ) : null;
                      })}
                    </div>

                    {/* ANSWER */}
                    <div className="answer-box">
                      ✅ Correct Answer: <b>{q.answer}</b>
                    </div>

                    {/* EXPLANATION */}
                    <div className="explanation-box">
                      <div className="explanation-title">Explanation</div>
                      <MathRenderer
                        text={q.explanation}
                        uniqueKey={`exp-${q.id}`}
                      />
                    </div>

                  </Card.Body>
                </Card>
              ))}
            </div>
          </MathJax>

          {/* PAGINATION */}
          {totalPages > 1 && (
            <div className="pdf-pagination mb-4">
              <Button
                className="btn-page"
                onClick={async () => {
                  const newPage = page - 1;
                  this.setState({ page: newPage, isRefetching: true });
                  await this.props.data.refetch({
                    id: parseInt(this.props.match.params.id) || 0,
                    institute_id: parseInt(Cookies.get("institutionid")),
                    page: newPage,
                    limit: limit
                  });
                  this.setState({ isRefetching: false });
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                disabled={page === 1}
              >
                Previous
              </Button>
              <span className="page-info">
                Page <b>{page}</b> of <b>{totalPages}</b> (Showing {startIndex + 1}-{Math.min(startIndex + limit, totalQuestions)} of {totalQuestions})
              </span>
              <Button
                className="btn-page"
                onClick={async () => {
                  const newPage = page + 1;
                  this.setState({ page: newPage, isRefetching: true });
                  await this.props.data.refetch({
                    id: parseInt(this.props.match.params.id) || 0,
                    institute_id: parseInt(Cookies.get("institutionid")),
                    page: newPage,
                    limit: limit
                  });
                  this.setState({ isRefetching: false });
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                disabled={page === totalPages}
              >
                Next
              </Button>
            </div>
          )}

          {/* MODAL */}
          <Modal
            show={this.state.showModal}
            onHide={this.handleModalClose}
            size="lg"
            enforceFocus={false}
            scrollable
            dialogClassName="questions-analysis-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>Edit Question</Modal.Title>
            </Modal.Header>



            <Modal.Body>

              <Row>
                <Col md={3}>
                  <Form.Label>Class</Form.Label>
                  <MultiSelect
                    options={classOptions}
                    value={this.state.classList}
                    onChange={(e) => this.handleMulti(e, "classList")}
                  />
                </Col>

                <Col md={3}>
                  <Form.Label>Exam</Form.Label>
                  <MultiSelect
                    options={examOptions}
                    value={this.state.examList}
                    onChange={(e) => this.handleMulti(e, "examList")}
                  />
                </Col>

                <Col md={3}>
                  <Form.Label>Subject</Form.Label>
                  <SelectDropDown
                    stateData={this.state.subjectVal}
                    handleChange={this.selecthandleChanges}
                    name="subject"
                    options={subjectOptions}
                  />
                </Col>

                <Col md={3}>
                  <Form.Label>Chapter</Form.Label>
                  <MultiSelect
                    options={this.state.chapterOptions}
                    value={this.state.chapterList}
                    onChange={(selected) => this.handleChapterChange(selected)}
                  />
                </Col>
              </Row>

              <Row className="mt-3">
                <Col md={3}>
                  <Form.Label>Topic</Form.Label>
                  <MultiSelect
                    options={this.state.topicOptions}
                    value={this.state.topicList}
                    onChange={(e) => this.handleMulti(e, "topicList")}
                  />
                </Col>

                <Col md={3}>
                  <Form.Label>Question Type</Form.Label>
                  <MultiSelect
                    options={questionTypeOptions}
                    value={this.state.questionTypeList}
                    onChange={(e) => this.handleMulti(e, "questionTypeList")}
                  />
                </Col>

                <Col md={3}>
                  <Form.Label>Complexity</Form.Label>
                  <SelectDropDown
                    stateData={this.state.complexityval}
                    handleChange={this.selecthandleChanges}
                    name="complexity"
                    options={complexityOptions}
                  />
                </Col>

                <Col md={3}>
                  <Form.Label>Time Duration</Form.Label>
                  <Form.Control
                    type="number"
                    value={this.state.timeduration}
                    onChange={(e) =>
                      this.setState({ timeduration: e.target.value })
                    }
                  />
                </Col>
              </Row>

              <Row className="mt-3">
                <Col md={3}>
                  <Form.Label>Type of Questions</Form.Label>
                  <MultiSelect
                    options={questionTypeOptions}
                    value={this.state.questionTypeList}
                    onChange={(e) => this.handleMulti(e, "questionTypeList")}
                  />
                </Col>

                <Col md={3}>
                  <Form.Label>Usage Set</Form.Label>
                  <SelectDropDown
                    stateData={this.state.usageSetVal}
                    handleChange={this.selecthandleChanges}
                    name="usageSet"
                    options={usageSetOptions}
                  />
                </Col>

                <Col md={3}>
                  <Form.Label>Question Theory</Form.Label>
                  <SelectDropDown
                    stateData={this.state.questionTheoryVal}
                    handleChange={this.selecthandleChanges}
                    name="questionTheory"
                    options={questionTheoryOptions}
                  />
                </Col>
              </Row>


              <div >
                {[
                  "question",
                  "option1",
                  "option2",
                  "option3",
                  "option4",
                  "explanation",
                ].filter(field => !isEditQtype8 || !field.startsWith("option")).map((field) => (
                  <Form.Group key={field} className="mb-3">
                    <Form.Label>{field.toUpperCase()}</Form.Label>

                    {/* ✅ LOADER */}
                    {this.state.editorLoading[field] && (
                      <div
                        style={{
                          height: "200px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "1px solid #ddd",
                          borderRadius: "6px",
                          background: "#fafafa",
                        }}
                      >
                        <Spinner animation="border" size="sm" />
                        <span style={{ marginLeft: 10 }}>Loading editor...</span>
                      </div>
                    )}

                    <div style={{ display: this.state.editorLoading[field] ? "none" : "block" }}>
                      <Editor
                        id={`editor_${field}`}
                        initialValue={this.getEditableContent(
                          this.state.selectedQuestion?.[field]
                        )}
                        onInit={(evt, editor) => {
                          if (!this.editors) this.editors = {};
                          this.editors[`editor_${field}`] = editor;

                          // ✅ mark loaded
                          this.setEditorLoaded(field);
                        }}
                        init={{
                          height: 200,
                          menubar: false,

                          plugins: [
                            "advlist",
                            "autolink",
                            "lists",
                            "link",
                            "image",
                            "charmap",
                            "preview",
                            "searchreplace",
                            "code",
                            "fullscreen",
                            "table",
                            "paste",
                            "help",
                            "wordcount",
                            "tiny_mce_wiris",
                          ],

                          toolbar:
                            "bold italic | alignleft aligncenter alignright | " +
                            "tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry | image | code",

                          paste_data_images: true,
                          automatic_uploads: true,

                          images_upload_handler: (blobInfo) => {
                            return new Promise((resolve, reject) => {
                              const reader = new FileReader();
                              reader.onload = () => resolve(reader.result);
                              reader.onerror = reject;
                              reader.readAsDataURL(blobInfo.blob());
                            });
                          },

                          entity_encoding: "raw",
                          content_style:
                            "body { font-size:16px; font-family: Proxima Nova; }",
                        }}
                      />
                    </div>
                  </Form.Group>
                ))}

                <Form.Group className="mb-3">
                  <Form.Label><b>Select Answer</b></Form.Label>

                  {isEditQtype8 ? (
                    <Form.Control
                      type="text"
                      placeholder="Enter numerical answer"
                      value={this.state.selectedAnswer}
                      onChange={(e) =>
                        this.setState({ selectedAnswer: e.target.value })
                      }
                    />
                  ) : (
                    <div className="answer-container">
                      {["A", "B", "C", "D"].map((opt) => {
                        const isChecked = this.state.selectedAnswer
                          ? this.state.selectedAnswer.split(",").map(x => x.trim()).includes(opt)
                          : false;
                        return (
                          <Form.Check
                            key={opt}
                            type="checkbox"
                            label={opt}
                            name="answer"
                            value={opt}
                            inline   // ✅ IMPORTANT
                            checked={isChecked}
                            onChange={(e) =>
                              this.handleCheckboxChange(opt, e.target.checked)
                            }
                          />
                        );
                      })}
                    </div>
                  )}
                </Form.Group>
              </div>


            </Modal.Body>

            <Modal.Footer className="d-flex justify-content-between">

              {/* LEFT SIDE MESSAGE */}
              <div>
                {this.state.saveMessage && (
                  <span style={{ color: this.state.saveError ? "red" : "green" }}>
                    {this.state.saveMessage}
                  </span>
                )}
              </div>

              {/* RIGHT SIDE BUTTONS */}
              <div>
                <Button
                  variant="secondary"
                  onClick={() => this.setState({ showModal: false })}
                  disabled={this.state.saving}
                >
                  Cancel
                </Button>
                &nbsp;&nbsp;
                <Button onClick={this.handleSave} disabled={this.state.saving}>
                  {this.state.saving ? (
                    <>
                      <Spinner size="sm" animation="border" /> Saving...
                    </>
                  ) : (
                    "Save"
                  )}
                </Button>
              </div>

            </Modal.Footer>
          </Modal>
        </Container>
      </MathJaxContext>
    );
  }
}
export default compose(
  withRouter,
  graphql(FETCH_QUESTIONS, {
    options: (props) => ({
      variables: {
        id: parseInt(props.match.params.id) || 0,
        institute_id: parseInt(Cookies.get("institutionid")),
        page: 1,
        limit: 25
      },
    }),
  }),
  graphql(FETCH_GLOBALS, {
    options: props => ({
      variables: {
        institution_id: parseInt(Cookies.get("institutionid"))
      }
    }),
    name: "globals"
  }),
  graphql(UPDATE_QUESTION, { name: "updateQuestionMutation" }) // 👈 ADD THIS
)(PdfQuestionsSec);